var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{staticClass:"m-b-l",attrs:{"src":"/cm/gres/faux/images/no_data.png"}}),_c('span',{staticClass:"ft-m ft-gray"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }